var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-tax-page"},[_c('BackTitle',{attrs:{"confirm-click":""},on:{"click":_vm.goBack}},[_vm._v("New tax")]),_c('TaxForm',{attrs:{"value":_vm.tax,"submitButtonText":"Add","isSubmitting":_vm.isSubmitting,"data-v-step":"8"},on:{"submit":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }